import React, { createContext, useContext, type ReactNode } from 'react';
import { useFlightPlanState } from '../hooks/useFlightPlan';

type FlightPlanContextValue = ReturnType<typeof useFlightPlanState>;

const FlightPlanContext = createContext<FlightPlanContextValue | null>(null);

export const FlightPlanProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const value = useFlightPlanState();
  return <FlightPlanContext.Provider value={value}>{children}</FlightPlanContext.Provider>;
};

export function useFlightPlan(): FlightPlanContextValue {
  const context = useContext(FlightPlanContext);
  if (!context) throw new Error('useFlightPlan must be used within FlightPlanProvider');
  return context;
}
